import { styled } from '@mui/material/styles';

export const PageArea = styled('div', { label: 'PageArea' })(({ theme }) => ({
  position: 'relative',
  cursor: '-webkit-grab',
  margin: theme.spacing(0, 'auto'),
  overflow: 'hidden',
  border: `2px solid ${theme.palette.grey[200]}`,
  borderRadius: 8,
}));

export const PageWrapper = styled('div', { label: 'PageWrapper' })(() => ({
  overflow: 'hidden',
  position: 'relative',
  display: 'block',
  direction: 'ltr!important' as 'ltr',
  width: '100%',

  '&:hover + .DocumentPage-controls': {
    opacity: 1,
  },

  '& .react-pdf__Page__canvas': {
    borderRadius: 8,
  },
}));
